import { render, staticRenderFns } from "./ReportBudget.vue?vue&type=template&id=b24685a8"
import script from "./ReportBudget.vue?vue&type=script&lang=js"
export * from "./ReportBudget.vue?vue&type=script&lang=js"
import style0 from "./ReportBudget.vue?vue&type=style&index=0&id=b24685a8&prod&lang=scss"
import style1 from "./ReportBudget.vue?vue&type=style&index=1&id=b24685a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports